import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";

import { SigninTemplate } from "components/entrance/signin";
import { fetchSignIn } from "redux/slices/signin/signinSlice";
import { updatePartnerInfo } from "redux/slices/partner/partnerSlice";
import { fetchUserInfo } from "redux/slices/user/userSlice";
import { getPhoneNumberFormat } from "utils/format";
import { checkForNewNotifications } from "redux/slices/notifications/notificationsSlice";
import CryptoJS from "crypto-js";

const Signin = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const [inputSubPassword, setInputSubPassword] = useState([]);

  const [signinInfo, setSigninInfo] = useState({
    phoneNumber: "010-",
    passCode: "",
    appToken: "",
    deviceOsCode: 0,
    deviceName: "",
    deviceMacId: "",
    isLogin: true,
  });

  useEffect(() => {
    const deviceInfo = navigator.userAgent;
    if (deviceInfo.includes("Android") && !window.ReactNativeWebView) {
      const adAppToken = window.CaremindBridge?.getAdAppToken() || "";
      const deviceOsCode = window.CaremindBridge?.getDeviceOsCode() || 0;
      const deviceName = window.CaremindBridge?.getDeviceName() || "";
      const deviceMacId = window.CaremindBridge?.getDeviceMacId() || "";
      setSigninInfo((previousValue) => ({
        ...previousValue,
        appToken: adAppToken,
        deviceOsCode: deviceOsCode,
        deviceName: deviceName,
        deviceMacId: deviceMacId,
      }));
    }

    // iOS RN
    window.addEventListener("message", ({ data }) => {
      if (typeof data === "string" && data.includes("deviceInfo")) {
        const objData = JSON.parse(data);
        if (objData?.name === "deviceInfo") {
          setSigninInfo((previousValue) => ({
            ...previousValue,
            appToken: objData.token || "",
            deviceOsCode: 2,
            deviceName: objData.deviceId || "",
            deviceMacId: objData.uniqueId || "",
          }));
        }
      }
    });
    // AOS RN
    document.addEventListener("message", ({ data }) => {
      if (typeof data === "string" && data.includes("deviceInfo")) {
        const objData = JSON.parse(data);
        if (objData?.name === "deviceInfo") {
          setSigninInfo((previousValue) => ({
            ...previousValue,
            appToken: objData.token || "",
            deviceOsCode: 1,
            deviceName: objData.deviceId || "",
            deviceMacId: objData.uniqueId || "",
          }));
        }
      }
    });
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage("getDeviceInfo");
    }

    return () => {
      setInputSubPassword([]);
    };
  }, []);

  const handleChange = (e, name) => {
    if (name === "phoneNumber") {
      const numFormat = getPhoneNumberFormat(e.target.value);
      if (numFormat) {
        setSigninInfo((previousValue) => ({
          ...previousValue,
          phoneNumber: numFormat,
        }));
      }
      return;
    }
    if (name === "passCode") {
      if (e.target.value.length >= inputSubPassword.length) {
        let spt = e.target.value.split("");
        const fIndex = spt.findIndex((f) => f !== "•");
        if (fIndex > -1) {
          const fWord = spt.at(fIndex);
          setInputSubPassword((preview) => {
            if (preview.length <= fIndex) {
              preview.push(fWord);
            } else {
              preview.splice(fIndex, 0, fWord);
            }
            return preview;
          });
        }
        spt = spt.map((m) => "•");
        e.target.value = spt.join("");
      } else {
        setInputSubPassword((preview) => {
          if (preview.length >= 0) {
            preview.pop();
          }
          return preview;
        });
      }
      setSigninInfo((previousValue) => ({
        ...previousValue,
        passCode: e.target.value,
      }));
    }
  };

  const handleClickFindPassword = () => {
    navigate("/entrance/findpass");
  };

  const handleClickDone = () => {
    let updatePhoneNumber = signinInfo.phoneNumber;
    if (signinInfo.phoneNumber.replace(/-/gi, "").length === 10) {
      const numFull = signinInfo.phoneNumber.replace(/-/gi, "");
      updatePhoneNumber = `${numFull.slice(0, 3)}-${numFull.slice(
        3,
        6
      )}-${numFull.slice(6, 10)}`;
    }
    const secretkey = "bodycodi-manager";
    const key = CryptoJS.enc.Utf8.parse(secretkey.substring(0, 32));
    const iv = CryptoJS.enc.Utf8.parse(secretkey.substring(0, 16));

    const cipherText = CryptoJS.AES.encrypt(inputSubPassword.join(""), key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    }).toString();
    dispatch(
      fetchSignIn({
        ...signinInfo,
        phoneNumber: updatePhoneNumber,
        passCode: cipherText,
      })
    )
      .unwrap()
      .then((result) => {
        if (!result) {
          setSigninInfo((previousValue) => ({
            ...previousValue,
            isLogin: false,
          }));
          return;
        }
        dispatch(updatePartnerInfo());
        dispatch(fetchUserInfo());
        dispatch(checkForNewNotifications());
        navigate(location.state?.from ? location.state.from : "/home", {
          replace: true,
        });
      })
      .catch((e) => {
        console.log(e);
      });
  };

  return (
    <SigninTemplate
      title="로그인"
      inputValue={signinInfo}
      inputValueChange={handleChange}
      buttonOnClick={handleClickDone}
      onClickFindPassword={handleClickFindPassword}
      onClickBack={() => navigate("/entrance", { replace: true })}
    />
  );
};
export default Signin;
